import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
  TableSelectRow,
} from "@carbon/react";
import { TO_BE_AGREED } from "../../../utils";
import i18next from "../../../i18n";

type MaterialsCheckboxListProps = {
  materials?: any;
  foundMaterials?: any;
  handleCheckboxChange: any;
  isChecked: any;
  searchTerm?: string;
};

/**
 * Step 2 candidate material table — a Carbon `DataTable` (`Table` + `TableSelectRow`) that lists
 * ONLY the not-yet-selected catalog (or search) results. Already-selected materials are pulled out
 * of this table and shown separately (see `SelectedMaterials` in `StepMaterials`), so the table
 * stays a clean "pick from here" list. Selection is external (`isChecked` = `ordersToSubmit`,
 * `handleCheckboxChange` toggles); checking a row removes it from this table and adds it to the
 * selected area. The `material-{id}` row-selection ids are preserved.
 */
const MaterialsCheckboxList = ({
  materials,
  isChecked,
  searchTerm,
  foundMaterials,
  handleCheckboxChange,
}: MaterialsCheckboxListProps) => {
  const unselected: any[] = !searchTerm
    ? (materials?.content ?? [])
        .filter((a: any) => a.material.active)
        .map((a: any) => a.material)
        .filter((m: any) => !isChecked.find((mat: any) => mat.id === m.id))
        .sort((a: any, b: any) =>
          a.globalMaterialName.localeCompare(b.globalMaterialName)
        )
    : (foundMaterials?.content ?? [])
        .filter((a: any) => a.active)
        .filter((m: any) => !isChecked.find((mat: any) => mat.id === m.id))
        .sort((a: any, b: any) =>
          a.globalMaterialName.localeCompare(b.globalMaterialName)
        );

  if (unselected.length === 0) {
    return (
      <p className="order-materials__notfound">
        {searchTerm
          ? i18next.t("tenders.notFound")
          : i18next.t("tenders.allMaterialsSelected")}
      </p>
    );
  }

  return (
    <Table size="lg" className="order-materials-table">
      <TableHead>
        <TableRow>
          <TableHeader aria-label={i18next.t("cta.select")} />
          <TableHeader>EAN</TableHeader>
          <TableHeader>{i18next.t("tenders.form.material")}</TableHeader>
          <TableHeader>{i18next.t("newMaterialForm.deliveryPlace")}</TableHeader>
        </TableRow>
      </TableHead>
      <TableBody>
        {unselected.map((material: any) => (
          <TableRow key={material.id}>
            <TableSelectRow
              id={`material-${material.id}`}
              name={`material-${material.id}`}
              ariaLabel={material.globalMaterialName}
              checked={false}
              onSelect={() => handleCheckboxChange(material)}
            />
            <TableCell className="order-materials-table__ean">
              {material.ean}
            </TableCell>
            <TableCell>{material.globalMaterialName}</TableCell>
            <TableCell>
              {material.deliveryPlace?.name ?? TO_BE_AGREED}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default MaterialsCheckboxList;
